module.exports = __webpack_public_path__ + "img/medal.04c6750b.svg";